<script>
    import { backOut } from 'svelte/easing';
    import LastWinsItem from './last-win-item.svelte';
    import { portal } from 'svelte-portal';

    export let results = [];

    function scaleWidth(node, options) {
        const { width } = node.getBoundingClientRect();

        return {
            ...options,
            css: (t, u) => {
                if (t === 1) {
                    node.style.marginRight = 0;
                }
                return `margin-right: ${(options.from - 1) * width * (1 - t)}px`;
            }
        };
    }

    $: {
        document.documentElement.style.removeProperty('--last-wins');
    }
</script>

<div
    class="absolute top-4 z-[100] h-14 !w-full overflow-hidden desktop:top-0 desktop:h-20"
    use:portal={'.wrapper-central'}
>
    <div
        class="flex h-7 w-full place-items-center gap-1 overflow-visible bg-black/[.48] pl-2 backdrop:blur-sm desktop:h-10 desktop:gap-2"
    >
        {#each results as result, index (result)}
            <div in:scaleWidth={{ from: 1.75, duration: 1000, delay: 500, easing: backOut }} class="relative">
                <LastWinsItem
                    color={result?.color}
                    multiplierValue={result.multiplier}
                    colorMultiplierValue={result?.colorMultiplier}
                    win={result.win}
                    isColorWin={result.isWinColor}
                    bonusGameType={result?.bonusGameType}
                />
            </div>
        {/each}
    </div>
</div>
